export const MAX_SCORE = 999;

// What a typed score field keeps: digits only, no leading zeros, at most three.
export function typedDigits(value) {
  return String(value || '')
    .replace(/\D/g, '')
    .replace(/^0+(?=\d)/, '')
    .slice(0, 3);
}

export function scoreFromDigits(digits) {
  return Math.min(MAX_SCORE, digits ? parseInt(digits, 10) : 0);
}

export function stepScore(value, delta) {
  return Math.max(0, Math.min(MAX_SCORE, (Number(value) || 0) + delta));
}
